import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfcaseService } from '../../../service/shelfcase/shelfcase.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9245',
  templateUrl: 'wa9245.component.html',
  styleUrls: ['wa9245.component.scss']
})
export class Wa9245Component implements OnInit {
  public componentTitle = 'WA9245:格納什器ケースマスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;


  public caseTx: String;
  public shelfTx: String;
  public caseCd: String;
  public shelfCd: String;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public shelfcaseId = 0;

  public shelfcaseTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.shelfcaseTx.maxLength)]);
  public layerNr = new FormControl('', [
      Validators.required,
      Validators.max(validation.layerNr.maxNr),
      Validators.min(validation.layerNr.minNr)]);
  public orderNr = new FormControl('', [
      Validators.required,
      Validators.max(validation.orderNr.maxNr),
      Validators.min(validation.orderNr.minNr)]);

  // build FormGroup

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private shelfcaseTxCls = '';
  private layerNrCls = '';
  private orderNrCls = '';
  private shelfcase = null;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private shelfcaseService: ShelfcaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled) {
      return;
    }

    let errors = false;
    if (this.shelfcaseTx.errors !== null) {
      this.shelfcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.layerNr.errors !== null) {
      this.layerNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.orderNr.errors !== null) {
      this.orderNr.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (errors) {
      return;
    }


    const shelfcaseTx = this.shelfcaseTx.value.trim();
    const layerNr = this.layerNr.value;
    const orderNr = this.orderNr.value;
    
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shelfcaseService
      .put(this.shelfcaseId, shelfcaseTx, layerNr, orderNr, 'wa9245')
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const rowShelfcase: object = JSON.parse(sessionStorage.getItem('rowShelfcase'));
    this.shelfcase = rowShelfcase;

    this.shelfcaseId = rowShelfcase['shelfcaseId'];
    this.shelfcaseTx.setValue(rowShelfcase['shelfcaseTx']);

    this.shelfCd = rowShelfcase['shelfCd'];
    this.shelfTx = rowShelfcase['shelfTx'];

    this.caseCd = rowShelfcase['caseCd'];
    this.caseTx = rowShelfcase['caseTx'];

    this.layerNr.setValue(rowShelfcase['layerNr']);
    this.orderNr.setValue(rowShelfcase['orderNr']);


    this.isSubmitButtonEnabled = false;
    console.log(this.shelfcase)
  }

  ngDoCheck() {
    if (!this.isShow) {
      return;
    }
    this.shelfcaseTxCls = this.shelfcaseTx.value === '' ? '' : (this.shelfcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.layerNrCls = this.layerNr.value == null ? '' : (this.layerNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.orderNrCls = this.orderNr.value == null ? '' : (this.orderNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
      ((this.shelfcaseTxCls === this.STRINGS_ACTIVE)
      && (this.layerNrCls === this.STRINGS_ACTIVE)
      && (this.orderNrCls === this.STRINGS_ACTIVE));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9245/wa9245.component.ts